import React from 'react';
import createHistory from 'history/createHashHistory';//路由切换地址

import { Menu, Icon } from 'antd';
import { connect } from "react-redux"//联系store的组件
import evn from "./../../../actions/index"//action的所有事件

import EventSet from "./../../../assets/PubJs/hcPub"

const SubMenu = Menu.SubMenu;
const history = createHistory();//定义history路由
let data = [
  
    {
        url: "Business", name: "主体管理", size: "14px", iconName:"icon-qiye", child: [
            { url: "/Content/Business/CompanyList", name: "主体设置", child: null }
        ]
    },
    {
        url: "Compromise", name: "先行和解", size: "20px", iconName: "icon-woshou", child: [
            { url: "/Content/Business/CompromiseListWait", name: "待处理", child: null },
            { url: "/Content/Business/CompormiseListAlready", name: "已处理", child: null },
            { url: "/Content/Business/CompromiseListOrder/proces", name: "工单查询", child: null },
        ]
    },
    {
        url: "CompanyRegistration", name: "自行和解", size: "14px", iconName: "icon-dengji", child: [
            { url: "/Content/Business/CompanyRegistration", name: "和解登记", child: null }
        ]
    },
    {
        url: "RepaymentCenter", name: "还款管理", size: "20px", iconName: "icon-iconfontbangzhu", child: [
            { url: "/Content/Business/RepaymentCenter", name: "还款管理", child: null },
        ]
    }
];

class App extends React.Component {
    state = {
        selectKey: [],
        OpenKeys: [],
        collapsed: true
    };

    //菜单点击事件
    handleClick = (e) => {
        if (e.key == "pdf.html") {
            window.open(pdfUrl)
            return
        }
        this.props.dispatch(evn.changeNavSelectkey(EventSet.getNavArr(e.keyPath[0])));
        this.props.dispatch(evn.changeTagKey("1"))
        if (history.location.pathname !== e.key || window.location.href.split("#")[1].split("?")[0]!==e.key) {
            history.push({
                pathname: e.key,
            })
        }
    };

    openchange(openKeys) {
        if (openKeys.length === 2) {
            openKeys = openKeys.toString().split(",")[1]
        }
        this.props.dispatch(evn.changeNavOpenkey(EventSet.getNavArr(openKeys.toString())))
    }

    //组件加载前的事件
    componentWillMount() {
       
    }

    //组件加载后的事件
    componentDidMount() {
        console.log(window.location.href, 'window.location.href');
    }

    render() {
        let _this = this
        return (
            <div id={"NavLast"}>
                <Menu
                    openKeys={this.props.openkey}
                    selectedKeys={this.props.selectkey}
                    mode="inline"
                    theme="light"
                    onClick={this.handleClick}
                    onOpenChange={this.openchange.bind(this)}
                    inlineCollapsed={this.props.coll}
                >
                    {
                        data.map(function (e) {
                            return (
                                <SubMenu key={e.url} title={<span>
                                    <i style={{ fontSize: e.size }} className={"myicon icon iconfont " + e.iconName}></i>
                                    {
                                        _this.props.coll ? "" : <span>{e.name}</span>
                                    }
                                </span>}>
                                    {
                                        e.child.map(function (v) {
                                            return <Menu.Item key={v.url}>{v.name}</Menu.Item>
                                        })
                                    }
                                </SubMenu>
                            )
                        })
                    }
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        openkey: state.NavKey.openkey,
        selectkey: state.NavKey.selectkey,
    }
};
export default connect(mapStateToProps)(App)









// WEBPACK FOOTER //
// ./src/components/Content/Wrap/Nav.js